import Icon from "@/components/ui/icon";
import PageTitle from "@/components/ui/page-title";
import api from "@/lib/api";
import {FileProps} from "@/types";
import {useQuery} from "@tanstack/react-query";
import Loading from "./ui/loading";
import FetchError from "./ui/fetch-error";
import DownloadLink from "./ui/download-link";

export default function OxcgrtDataClient() {
  const {data, error, isPending} = useQuery<Record<string, FileProps>, Error>({
    queryKey: ["cms-oxcgrt-download"],
    queryFn: () => api.get("/cms/oxcgrt/download/"),
  });

  if (isPending) return <Loading />;
  if (error) return <FetchError message={error.message} />;

  const getFile = (filename: string) => {
    const file = data?.[filename];
    return file?.file_size ? file : undefined;
  };

  const rFile = getFile("Harmonized_OxCGRT_Long_R.zip");
  const sasFile = getFile("Harmonized_OxCGRT_Long_SAS.zip");
  const spssFile = getFile("Harmonized_OxCGRT_Long_SPSS.zip");
  const stataFile = getFile("Harmonized_OxCGRT_Long_Stata.zip");

  return (
    <>
      <PageTitle title='Data Downloads: Gateway Harmonized OxCGRT Data' />

      <div className='card'>
        <div className='card-header'>
          <ul className='nav nav-pills card-header-pills d-flex align-items-center gap-4'>
            <li className='nav-item'>
              <p className='nav-link mb-0 fw-bold text-dark'>
                Harmonized OxCGRT Data
              </p>
            </li>

            {stataFile && (
              <li className='nav-item g2-link-blue text-decoration-none'>
                <DownloadLink file={stataFile} target='_blank'>
                  <Icon icon='file-earmark-arrow-down' me={1} />
                  Data (Stata)
                </DownloadLink>
              </li>
            )}

            {rFile && (
              <li className='nav-item g2-link-blue text-decoration-none'>
                <DownloadLink file={rFile} target='_blank'>
                  <Icon icon='file-earmark-arrow-down' me={1} />
                  Data (R)
                </DownloadLink>
              </li>
            )}

            {sasFile && (
              <li className='nav-item g2-link-blue text-decoration-none'>
                <DownloadLink file={sasFile} target='_blank'>
                  <Icon icon='file-earmark-arrow-down' me={1} />
                  Data (SAS)
                </DownloadLink>
              </li>
            )}

            {spssFile && (
              <li className='nav-item g2-link-blue text-decoration-none'>
                <DownloadLink file={spssFile} target='_blank'>
                  <Icon icon='file-earmark-arrow-down' me={1} />
                  Data (SPSS)
                </DownloadLink>
              </li>
            )}
          </ul>
        </div>
      </div>
    </>
  );
}
